import cloneDeep from 'lodash/cloneDeep';

export function removeBill(state, billId) {
  const newState = cloneDeep(state);
  newState.collection = newState.collection.filter(({ id }) => id != billId);
  return newState;
}